module.exports = __webpack_public_path__ + "img/team-availability.b7d965b9.webp";